// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"957":"dbdc3ad1b7e19048","1791":"41bd07bfb72a7916","2888":"5e2691f87dc2b1c1"}[chunkId] + ".css";
};